/**
 * Telegram label prefixes API Service (KAN-722): префиксы меток аккаунтов.
 *
 *   GET    /api/v1/telegram-label-prefixes/                 - префиксы организации
 *   POST   /api/v1/telegram-label-prefixes/                 - {code, phone_prefixes?, description?}
 *   PATCH  /api/v1/telegram-label-prefixes/{id}/            - любые поля
 *   DELETE /api/v1/telegram-label-prefixes/{id}/
 *   GET    /api/v1/telegram-label-prefixes/suggest/?phone=  - {code|null, next_label|null}
 * Ошибки: 400 {detail}.
 */
import apiClient from './client';
import type {
  LabelPrefixId,
  LabelPrefixSuggestion,
  TelegramLabelPrefix,
  TelegramLabelPrefixBody,
} from '@/types/telegramLabelPrefix';

const BASE = '/api/v1/telegram-label-prefixes/';

function itemUrl(id: LabelPrefixId): string {
  return `${BASE}${encodeURIComponent(String(id))}/`;
}

export const telegramLabelPrefixesApi = {
  list: async (): Promise<TelegramLabelPrefix[]> => {
    const d = (await apiClient.get(BASE)).data;
    return Array.isArray(d) ? d : (d?.results ?? []);
  },
  create: async (data: TelegramLabelPrefixBody): Promise<TelegramLabelPrefix> =>
    (await apiClient.post(BASE, data)).data,
  update: async (
    id: LabelPrefixId,
    data: TelegramLabelPrefixBody
  ): Promise<TelegramLabelPrefix> => (await apiClient.patch(itemUrl(id), data)).data,
  remove: async (id: LabelPrefixId): Promise<void> => {
    await apiClient.delete(itemUrl(id));
  },
  suggest: async (phone: string): Promise<LabelPrefixSuggestion> =>
    (await apiClient.get(`${BASE}suggest/`, { params: { phone } })).data,
};

export default telegramLabelPrefixesApi;
